<div class="card">
    <p-chart type="line" [data]="chartData" [options]="chartOptions" />
</div>